var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-footer',{class:{ 'guest': !this.$store.state.signedIn }},[_c('p',{staticClass:"footer-copyright mb-0 py-3 text-center"},[_c('span',[_vm._v(" © "+_vm._s(new Date().getFullYear()))]),_c('a',{attrs:{"href":"https://bndbs.ir"}},[_vm._v("تمام حقوق مادی و معنوی این وب سایت محفوظ می باشد و هرگونه کپی برداری از ان پیگرد قانونی دارد.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }